export default __webpack_public_path__ + "static/media/RebarGun.256.3e9d9401.png";